import { Plus } from 'lucide-react';
import { useState } from 'react';

import { AddPromptVariableForm } from './components/AddVariable';
import { VariablesSearchForm } from './components/VariablesSearch';
import { VariablesTable } from './components/VariablesTable';

import { Button } from '@/components/ui/Button';
import { Card, CardContent } from '@/components/ui/Card';

export function AdminPromptVariables() {
  const [name, setName] = useState<string>('');

  const [showVariableForm, setShowVariableForm] = useState(false);

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <div className="mt-4">
          <h2 className="text-xl font-semibold text-gray-900">Variables</h2>
          <p className="mt-1 text-gray-600">
            Manage query-based variables for prompts
          </p>
        </div>
        <Button onClick={() => setShowVariableForm(true)} className="gap-2">
          <Plus className="h-4 w-4" />
          Create New Variable
        </Button>
      </div>
      <Card className="mb-6">
        <CardContent className="space-y-4 p-4">
          <VariablesSearchForm searchTerm={name} onSearchChange={setName} />
        </CardContent>
      </Card>
      <VariablesTable name={name} />

      <AddPromptVariableForm
        open={showVariableForm}
        onClose={() => setShowVariableForm(false)}
        filter={{ name: name ? [name] : undefined }}
      />
    </div>
  );
}
